import { Outlet } from "react-router";
import { informationTypesGridPageRoutes, prefetchInformationTypesGridViewAndForm } from "./InformationTypesGridPage";
import { InformationTypesUpsell } from "./InformationTypesUpsell";
import { getCurrentOrganisation, useCurrentOrganisation } from "../../root/CurrentOrganisationProvider";
import type { NavigationItemType } from "../../root/layout/SidebarMenuItem";
import type { Paths } from "../../shared/usePrivacyNavigate";

const InformationTypesRouteElement = () =>
  useCurrentOrganisation().classificationEnabled ? <Outlet /> : <InformationTypesUpsell />;

export const route: NavigationItemType["route"] = {
  path: "primary-assets",
  element: <InformationTypesRouteElement />,
  children: informationTypesGridPageRoutes,
};
export const to = (paths: Paths) => paths.informationTypesGrid();
export const prefetch = () =>
  void getCurrentOrganisation().then(organisation => {
    if (organisation?.classificationEnabled) prefetchInformationTypesGridViewAndForm();
  });
